import { createAction, createActionGroup, props } from '@ngrx/store';
import { IEnrollment } from 'src/app/core/models/enrollments.model';
import { AppointmentAction } from 'src/app/shared/models/appointment-dialog.model';

const enrollmentProps = props<{ enrollment: IEnrollment }>;
const enrollmentErrorProps = props<{
  enrollment: IEnrollment;
  error: string[];
}>;
const enrollmentMessageProps = props<{
  enrollment: IEnrollment;
  successMessage?: string;
}>;

export const CoreEnrollmentActions = createActionGroup({
  source: 'Core Enrollment',
  events: {
    'Start Sub Appointment': enrollmentProps(),
    'Start Direct Appointment': enrollmentProps(),
    'Start Disconnect': enrollmentProps(),
    'Activate Appointment': enrollmentMessageProps(),
    'Activate Appointment Success': enrollmentMessageProps(),
    'Activate Appointment Error': enrollmentErrorProps(),
    'Preconfigure Appointment': enrollmentMessageProps(),
    'Preconfigure Appointment Success': enrollmentMessageProps(),
    'Preconfigure Appointment Error': enrollmentErrorProps(),
    'Request Sub Appointment': enrollmentMessageProps(),
    'Request Sub Appointment Success': enrollmentMessageProps(),
    'Request Sub Appointment Error': enrollmentErrorProps(),
    'Edit Direct Appointment': enrollmentProps(),
    'View Appointment': enrollmentProps(),
    'Deactivate Appointment': enrollmentMessageProps(),
    'Deactivate Appointment Success': enrollmentMessageProps(),
    'Deactivate Appointment Error': enrollmentErrorProps(),
    'Start Compliance Form': props<{ enrollmentId: string }>(),
  },
});

const enrollmentDialogProps = props<{
  data: {
    type: AppointmentAction;
    enrollment: IEnrollment;
    isDirect: boolean;
    isFTW: boolean;
  };
}>;
export const EnrollmentDialogActions = createActionGroup({
  source: 'Enrollment Dialog',
  events: {
    'Open Dialog': enrollmentDialogProps(),
    'Request Sub Appointment': enrollmentMessageProps(),
    'Edit Direct Appointment': enrollmentMessageProps(),
    'Preconfigure Appointment': enrollmentMessageProps(),
    'Deactivate Appointment': enrollmentMessageProps(),
  },
});

/**
 * Loading The Enrollments
 */
export const GetAllEnrollments = createAction(
  '[Enrollments] - Get All Enrollments',
);

export const GetAllEnrollmentsSuccess = createAction(
  '[Enrollments] - Get All Enrollments Success',
  props<{ enrollments: IEnrollment[] }>(),
);

export const GetAllEnrollmentsError = createAction(
  '[Enrollments] - Get All Enrollments Error',
  props<{ error: Error }>(),
);

/**
 * @deprecated Appointments V2
 * Update Base Enrollment
 */
export const UpdateEnrollmentAction = createAction(
  '[Enrollments] - Toggle Enrollment',
  props<{
    enrollment: IEnrollment;
    activeStatus: boolean;
    successMessage?: string;
  }>(),
);

/**
 * @deprecated Appointments V2
 */
export const UpdateEnrollmentSuccessAction = createAction(
  '[Enrollments] - Toggle Enrollment Success',
  props<{ enrollment: IEnrollment }>(),
);

/**
 * @deprecated Appointments V2
 */
export const UpdateEnrollmentErrorAction = createAction(
  '[Enrollments] - Toggle Enrollment ERROR',
  props<{ error: string[]; enrollment: IEnrollment }>(),
);

/**
 * TODO: possibly move to Quotes feature
 */
export const QuoteViewUpdateEnrollmentCredentials = createAction(
  '[Quote View] - Update Enrollment Credentials',
  props<{ enrollment: IEnrollment }>(),
);
export const QuoteViewUpdateEnrollmentCredentialsSuccess = createAction(
  '[Quote View] - Update Enrollment Credentials Success',
  props<{ enrollment: IEnrollment }>(),
);
export const QuoteViewUpdateEnrollmentCredentialsError = createAction(
  '[Quote View] - Update Enrollment Credentials Error',
  props<{ error: string[]; enrollment: IEnrollment }>(),
);

/**
 * @deprecated Appointments V2
 * Update Carrier Attributes
 */
export const UpdateCarrierAttributes = createAction(
  '[Enrollments] - Update Carrier Attributes',
  props<{ enrollment: IEnrollment }>(),
);

/**
 * @deprecated Appointments V2
 */
export const UpdateCarrierAttributesSuccess = createAction(
  '[Enrollments] - Update Carrier Attributes Success',
  props<{ enrollment: IEnrollment }>(),
);

/**
 * @deprecated Appointments V2
 */
export const UpdateCarrierAttributesError = createAction(
  '[Enrollments] - Update Carrier Attributes Error',
  props<{ error: string[]; enrollment: IEnrollment }>(),
);

/**
 * Active Direct Enrollments
 * TODO: possibly move to Welcome feature
 */
export const ActivateDirectAppointments = createAction(
  '[Enrollments] - Activate Direct Enrollments',
  props<{ enrollments: IEnrollment[] }>(),
);
export const ActivateDirectAppointmentsSuccess = createAction(
  '[Enrollments] - Activate Direct Enrollments Success',
  props<{ enrollments: IEnrollment[] }>(),
);
export const ActivateDirectAppointmentsError = createAction(
  '[Enrollments] - Activate Direct Enrollments Error',
  props<{
    error: Error;
    enrollments: IEnrollment[];
    failedEnrollment: IEnrollment;
  }>(),
);

/**
 * @deprecated Appointments V2
 * Enrollment Appointments Dialog
 */

export const UpdateShowEnrollmentAppointmentDialog = createAction(
  '[Enrollments] - Toggle Enrollment Appointment Dialog',
  props<{ showDialog: boolean }>(),
);

/**
 * @deprecated Appointments V2
 * Update Enrollment Appointments
 */
export const UpdateEnrollmentAppointmentAction = createAction(
  '[Enrollments] - Toggle Enrollment Appointment',
  props<{
    enrollment: IEnrollment;
    activeStatus: boolean;
    successMessage?: string;
  }>(),
);

/**
 * @deprecated Appointments V2
 */
export const UpdateEnrollmentAppointmentSuccess = createAction(
  '[Enrollments] - Toggle Enrollment Appointment Success',
  props<{ enrollment: IEnrollment }>(),
);

/**
 * @deprecated Appointments V2
 */
export const UpdateEnrollmentAppointmentFailure = createAction(
  '[Enrollments] - Toggle Enrollment Appointment Failure',
);

export const CancelEnrollmentAttempt = createAction(
  '[Enrollments] - Cancel Attempted Enrollment Appointment Creation',
  props<{ enrollment: IEnrollment }>(),
);

/**
 * Request Enrollment Appointments
 */
export const RequestEnrollmentAppointments = createAction(
  '[Enrollments] - Request Enrollment Appointments',
  props<{ enrollments: IEnrollment[]; showSuccessMessage?: boolean }>(),
);

export const RequestEnrollmentAppointmentsSuccess = createAction(
  '[Enrollments] - Request Enrollment Appointments Success',
  props<{ enrollments: IEnrollment[]; showSuccessMessage?: boolean }>(),
);

export const RequestEnrollmentAppointmentsError = createAction(
  '[Enrollments] - Request Enrollment Appointments Error',
  props<{ error: Error }>(),
);

/**
 * @deprecated use CoreEnrollmentActions.startComplianceForm
 */
export const NavigateToAppointmentsComplianceForm = createAction(
  '[Enrollments] Navigate to appointments compliance form',
  props<{ enrollmentId: string }>(),
);

/**
 * @deprecated Appointments V2
 */
export const NavigateToComplianceFormFromAppointmentsDialog = createAction(
  '[Enrollments] Navigate to appointments compliance form from carrier appointments dialog',
  props<{ enrollmentId: string; successMessage: string }>(),
);
